const SHOW_DASHBOARD = 'SHOW_DASHBOARD';
const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';

const showDashboard = visible => {
    return {
        type: SHOW_DASHBOARD,
        visible
    };
}

const getDashboardData = data => {
    return {
        type: GET_DASHBOARD_DATA,
        data
    }
} 

const setDashboardData = data => {
    return {
        type: SET_DASHBOARD_DATA,
        data
    }
} 

export default {
    types: {
        SHOW_DASHBOARD,
        GET_DASHBOARD_DATA,
        SET_DASHBOARD_DATA
    },
    actions: {
        showDashboard,
        getDashboardData,
        setDashboardData
    }
}